import { ColorX } from "../../../../STATIC";

let styles = {
  header: {
    padding: 5,
    width: "100%"
  },
  acbox: {
    borderWidth: 1,
    borderRadius: 5,
    borderColor: ColorX.CSS("gambotBlue", 0.2),
    borderStyle: "solid",
    paddingLeft: 5,
    paddingRight: 5
  },
  actextinput: {
    borderWidth: 0,
    flex: 1
  }
};

export default styles;